import React, { useState } from "react";

import { FormHelperText, MenuItem, Select } from "@mui/material";
import { useController } from "react-hook-form";

import { ReactComponent as ArrowDown } from "../../../Assets/Images/ArrowDown.svg";
import { FormItemsWrap } from "../../molecules/Wrap/Wrap";
import Label from "./Label";

export const RemoteSelectMultiple = ({
  control,
  label,
  name,
  menuItemLabel,
  menuItemKey,
  options,
  size,
  fullWidth,
  required,
  placeholder,
  selectedValues,
  onSelectDeselectAll,
  height,
  fontSize,
}) => {
  const { field, fieldState } = useController({
    control: control,
    name: name,
  });
  const [selectedItems, setSelectedItems] = useState(
    selectedValues && selectedValues.length != 0 ? selectedValues : [],
  );

  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue.includes("selectAll")) {
      let temp = [];
      options.map((item) => temp.push(item[menuItemKey]));
      setSelectedItems(temp);
      onSelectDeselectAll(temp);
    } else if (selectedValue.includes("DESELECTALL")) {
      setSelectedItems([]);
      onSelectDeselectAll([]);
    } else {
      if (selectedItems.length != 0) {
        setSelectedItems(selectedValue);
        onSelectDeselectAll(selectedValue);
      } else {
        let temp = [];
        temp.push(...selectedItems);
        const initialLength = temp.length;
        temp = temp.filter((item) => item !== selectedValue);
        const finalLength = temp.length;

        if (initialLength == finalLength) {
          temp.push(...selectedItems, selectedValue);
        }
        setSelectedItems(temp);
        onSelectDeselectAll(temp);
        field.onChange(temp);
      }
    }
  };

  return (
    <FormItemsWrap>
      <Label required={required} label={label} />
      <Select
        fullWidth={fullWidth}
        IconComponent={ArrowDown}
        variant="outlined"
        size={size ?? "small"}
        displayEmpty
        multiple={selectedItems.length != 0}
        value={selectedItems}
        onChange={handleSelectChange}
        error={fieldState?.invalid}
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "pre",
          height: height || null,
          fontSize: fontSize || "13px",
          ".MuiSelect-icon": {
            marginRight: "10px",
          },
        }}
        placeholder={placeholder}
      >
        <MenuItem skey={Math.random() * 10} value="" disabled>
          <span
            style={{
              fontSize: fontSize || "13px",
              color: "#8E8E93",
            }}
          >
            {placeholder}
          </span>
        </MenuItem>
        <MenuItem
          key={"selectAll"}
          value={"selectAll"}
          style={{ fontSize: fontSize || "13px" }}
        >
          Select All
        </MenuItem>
        <MenuItem
          key={"DESELECTALL"}
          value={"DESELECTALL"}
          style={{ fontSize: fontSize || "13px" }}
        >
          Deselect All
        </MenuItem>

        {options &&
          options?.length &&
          options?.length > 0 &&
          options.map((item, index) => (
            <MenuItem
              key={index}
              value={item[menuItemKey]}
              style={{ fontSize: fontSize || "13px", color: "#37373A" }}
            >
              {item[menuItemLabel]}
            </MenuItem>
          ))}
      </Select>
      {fieldState?.error?.message && (
        <FormHelperText style={{ color: "red" }}>
          {fieldState?.error?.message}
        </FormHelperText>
      )}
    </FormItemsWrap>
  );
};
